import React from 'react';
import { Loader2 } from 'lucide-react';

export default function PageLoadingState({
  title = 'Loading content',
  message = 'Please wait while the page loads up.',
  className = '',
}) {
  return (
    <div
      className={`min-h-screen flex items-center justify-center pt-24 px-6 ${className}`}
      data-testid="page-loading-state"
    >
      <div className="w-full max-w-3xl rounded-3xl border border-primary/20 bg-primary/5 px-6 py-10 text-center shadow-[0_0_40px_rgba(139,92,246,0.08)] backdrop-blur-sm">
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full border border-primary/20 bg-primary/10">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
        <h2 className="text-2xl md:text-3xl font-semibold tracking-tight mb-3">{title}</h2>
        <p className="text-sm md:text-base text-muted-foreground max-w-xl mx-auto">
          {message}
        </p>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
          {Array.from({ length: 3 }).map((_, index) => (
            <div
              key={index}
              className="rounded-2xl border border-white/10 bg-white/5 p-4 text-left"
            >
              <div className="h-28 rounded-xl bg-white/10 animate-pulse mb-4" />
              <div className="h-5 w-2/3 rounded bg-white/10 animate-pulse mb-3" />
              <div className="h-4 w-full rounded bg-white/10 animate-pulse mb-2" />
              <div className="h-4 w-4/5 rounded bg-white/10 animate-pulse" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
